import { render, staticRenderFns } from "./partnerForm.vue?vue&type=template&id=5648aa72&scoped=true&"
import script from "./partnerForm.vue?vue&type=script&lang=js&"
export * from "./partnerForm.vue?vue&type=script&lang=js&"
import style0 from "./partnerForm.vue?vue&type=style&index=0&id=5648aa72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5648aa72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5648aa72')) {
      api.createRecord('5648aa72', component.options)
    } else {
      api.reload('5648aa72', component.options)
    }
    module.hot.accept("./partnerForm.vue?vue&type=template&id=5648aa72&scoped=true&", function () {
      api.rerender('5648aa72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/partnerForm.vue"
export default component.exports